import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TruckDimensions {
  name: string;
  width: number;
  depth: number;
  totalAreaSqInches: number;
}

export const TRUCK_SIZES: Record<string, TruckDimensions> = {
  '24ft_box': {
    name: '24-foot Box Truck',
    width: 96,
    depth: 288,
    totalAreaSqInches: 27648,
  },
  '53ft_semi': {
    name: '53-foot Semi Trailer',
    width: 102,
    depth: 636,
    totalAreaSqInches: 64872,
  },
  '40ft_container': {
    name: '40-foot High Cube Container',
    width: 92,
    depth: 472,
    totalAreaSqInches: 43424,
  },
  'unknown': {
    name: 'Unknown',
    width: 0,
    depth: 0,
    totalAreaSqInches: Infinity,
  },
};

export type CalculatorMode = '2d' | '3d';

interface TruckState {
  selectedTruckSize: string | null;
  showTruckModal: boolean;
  calculatorMode: CalculatorMode;
  setTruckSize: (size: string) => void;
  setShowTruckModal: (show: boolean) => void;
  setCalculatorMode: (mode: CalculatorMode) => void;
  getTruckDimensions: () => TruckDimensions | null;
}

export const useTruckStore = create<TruckState>()(
  persist(
    (set, get) => ({
      selectedTruckSize: null,
      showTruckModal: false,
      calculatorMode: '2d',
      setTruckSize: (size: string) => {
        set({ selectedTruckSize: size, showTruckModal: false });
      },
      setShowTruckModal: (show: boolean) => {
        set({ showTruckModal: show });
      },
      setCalculatorMode: (mode: CalculatorMode) => {
        set({ calculatorMode: mode });
      },
      getTruckDimensions: () => {
        const { selectedTruckSize } = get();
        return selectedTruckSize ? TRUCK_SIZES[selectedTruckSize] || null : null;
      },
    }),
    {
      name: 'truck-storage',
    }
  )
);
